<script>
    import {enhance, applyAction} from '$app/forms';
    import {customer} from "$lib/state/customer";
    import {cart} from "$lib/state/cart.js";
    import {getRecaptcha} from "$lib/utils/getRecaptcha";
    import {VerifyEmailAddress} from "$lib/utils/verifyEmailAddress";
    import {dispatchCustomEvent, LOGIN} from "$lib/utils/events";

    /** @type {String}*/
    let email = "";
    /** @type {string}*/
    let password = "";
    /** @type {string}*/
    let msgError = "";

    let loading = false;

    const submit = async ({ formElement, formData, action, cancel }) => {

        msgError = "";
        loading = true;
        const recaptcha = await getRecaptcha()
        formData.set('x-recaptcha', recaptcha)

        return async ({ result }) => {
            // `result` is an `ActionResult` object
            if (result.type === 'success')
            {
                console.log(result)
                customer.set(result.data.magentoCustomer)
                if (result.data.cart !== null)
                {
                    cart.set(result.data.cart)
                }

                dispatchCustomEvent(LOGIN, result.data.magentoCustomer.email)

                loading = false;
                await applyAction(result)

                closeModal()
            }

            if (result.type === 'failure')
            {
                loading = false;
                msgError = result.data.message;
            }
        };
    }

    const closeModal = () => {
        /** @type {?HTMLDialogElement}*/
        const modalSignin = /** @type {HTMLDialogElement} */(document.querySelector("#signin-account"));
        modalSignin.close();
    };
</script>

<div class="form-content">
    <h1>Sign In</h1>
    {#if !VerifyEmailAddress(email).isValid && VerifyEmailAddress(email).msg && email.length > 0}
        <p class="message red">{VerifyEmailAddress(email).msg}</p>
    {:else if msgError !== ""}
        <p class="message red">{msgError}</p>
    {:else}
        <p class="message"></p>
    {/if}
    <form action="/customers/signin?/customerSignin" method="post" use:enhance={submit}>
        {#if loading}
            <div class="lds-dual-ring"></div>
        {:else}
            <input
                    type="email"
                    bind:value={email}
                    name="username"
                    placeholder="E-mail"
                    class:wrong={!VerifyEmailAddress(email).isValid && email.length > 0}
            />
            <div class="password-content">
                <input
                        type="password"
                        name="password"
                        placeholder="Password"
                        bind:value={password}
                />
            </div>
            <a href="/forget-password" on:click={closeModal}>
                Forgot your password?*
            </a>
            <br/>
            <button type="submit" class="btn-action-url">
                <span>Sign In</span>
            </button>
        {/if}
    </form>
</div>

<style>
    .form-content {
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-rows: 10rem 5rem 1fr;
        justify-items: center;
        gap: 1rem;
    }

    .form-content h1 {
        font-size: clamp(2rem, 5svw, 5rem);
        font-family: sirenia;
        color: var(--orange);
    }

    .message {
        font-size: 1.6rem;
        opacity: 0;
        transition: all 500ms ease;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80%;
        border-radius: 4rem;
        line-height: 1;
        padding: 0 3rem;
    }

    .message.red {
        color: var(--white);
        background-color: var(--red);
        opacity: 1;
    }

    form {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-width: 60rem;
        margin: 0 auto;
        gap: 2rem;
    }

    form input {
        border: none;
        width: 100%;
        padding: 2rem 0;
        text-align: center;
        border-bottom: 0.2rem solid var(--orange);
        font-size: 1.8rem;
        font-family: sirenia;
        outline: none;
        color: var(--orange);
    }

    form .password-content {
        width: 100%;
        position: relative;
    }

    form input.wrong {
        color: var(--red);
        border-bottom: 0.2rem solid var(--red);
    }

    form a {
        font-size: 2rem;
        text-decoration: none;
        color: var(--orange);
        padding: 1rem;
        margin-top: 4rem;
        position: relative;
    }

    form a::before {
        content: "";
        width: 100%;
        height: 0.2rem;
        background-color: var(--orange);
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 1rem;
        transition: all 300ms ease;
    }


    .lds-dual-ring,
    .lds-dual-ring:after {
        box-sizing: border-box;
    }
    .lds-dual-ring {
        display: inline-block;
        width: 80px;
        height: 80px;
    }
    .lds-dual-ring:after {
        content: " ";
        display: block;
        width: 64px;
        height: 64px;
        margin: 8px;
        border-radius: 50%;
        border: 6.4px solid currentColor;
        border-color: currentColor transparent currentColor transparent;
        animation: lds-dual-ring 1.2s linear infinite;
    }
    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
